export default "__VITE_ASSET__DymmWSkj__"